import { render, staticRenderFns } from "./national.vue?vue&type=template&id=4fafcb8e&scoped=true&"
import script from "./national.vue?vue&type=script&lang=js&"
export * from "./national.vue?vue&type=script&lang=js&"
import style0 from "./national.vue?vue&type=style&index=0&id=4fafcb8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fafcb8e",
  null
  
)

export default component.exports